export class ManualClaimProfile {
  public firstName: string;
  public lastName: string;
  public email: string;
  public phone: string;
  public website: string;
  public message: string;
}
